import React from "react"
import ScriptTagBlock from "../shared/ScriptTagBlock.jsx"

const SKIP_KEY = "shopshift_skip_install"

export default function InstallScriptStep({ t, shop }) {
  const installed = !!shop?.script_installed
  const apiKey = shop?.api_key

  const handleSkip = () => {
    try { window.localStorage.setItem(SKIP_KEY, "1") } catch { /* private mode */ }
    window.location.assign("/")
  }

  const handleContinue = () => {
    window.location.assign("/")
  }

  return (
    <div className="space-y-6">
      <h1 className="text-[28px] font-medium tracking-[-0.035em] text-ink-primary">
        {t("dashboard.onboarding.install_script.title")}
      </h1>
      <p className="text-sm text-ink-secondary" style={{ lineHeight: 1.55 }}>
        {t("dashboard.onboarding.install_script.lede")}
      </p>

      <ScriptTagBlock t={t} apiKey={apiKey} />

      <p className="text-[13px] text-ink-tertiary" style={{ lineHeight: 1.55 }}>
        {t("dashboard.onboarding.install_script.instructions", { head: "<head>" })}
      </p>

      <div
        className={`flex items-center gap-3 rounded-card border p-4 ${
          installed
            ? "border-rule bg-winner-fill"
            : "border-rule bg-surface-subtle"
        }`}
      >
        <span
          aria-hidden
          className={`inline-block w-[8px] h-[8px] rounded-full ${installed ? "" : "animate-pulse"}`}
          style={{
            background: installed ? "var(--color-winner-dot)" : "var(--color-ai)"
          }}
        />
        <span
          className="text-[13px] font-medium"
          style={{ color: installed ? "var(--color-winner)" : "var(--color-ink-secondary)" }}
        >
          {installed
            ? t("dashboard.onboarding.install_script.status_installed")
            : t("dashboard.onboarding.install_script.status_waiting")}
        </span>
      </div>

      <div className="flex items-center gap-4 pt-2">
        <button
          type="button"
          onClick={handleContinue}
          disabled={!installed}
          className="inline-block bg-brand text-ink-on-dark rounded-button px-4 py-2 text-[13px] font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {t("dashboard.onboarding.install_script.button_continue")}
        </button>
        <button
          type="button"
          onClick={handleSkip}
          className="text-[13px] font-medium text-ai hover:underline"
        >
          {t("dashboard.onboarding.install_script.button_skip")}
        </button>
      </div>
    </div>
  )
}
